import { Link } from "react-router-dom";
import CollapseHeader from "../../core/common/collapse-header";

const ClientsEdit = () => {
  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <h4 className="page-title">
                      Client - Lendtek<span className="count-title">123</span>
                      </h4>
                    </div>
                    <div className="col-8 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                <div className="card">
                 
                  <div className="card-body">
                    <div className="col-xs-12">
                      <div className="box">
                        <form
                          method="post"
                          role="form"
                          name="editForm"
                          id="editForm"
                          action="https://portal.voiptella.com/client/1"
                        >
                          <input
                            type="hidden"
                            name="_token"
                            value="NCJKyCAacIlADlO0yZraQhIO0iuYBJ9STRk3fjz1"
                          />{" "}
                          <input
                            type="hidden"
                            className="form-control"
                            name="id"
                            value="1"
                            id="id"
                          />
                          <div className="box-body">
                            <div className="row mb-2">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="form-label">Name </label>
                                  <div className="input-group">
                                    <span className="input-group-text ">
                                      <i className="ti-user"></i>
                                    </span>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="company_name"
                                      id="company_name"
                                      value="Lendtek"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="form-label">Status </label>
                                  <div className="select2-container select2-container--default status-label-container">
                                    <select
                                      className="form-select"
                                      name="mca_crm"
                                      id="enable_mca_crm"
                                    >
                                      <option value="0">No</option>
                                      <option value="1">Yes</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="form-label">
                                    Building/Street{" "}
                                  </label>
                                  <div className="input-group">
                                    <span className="input-group-text ">
                                      <i className="ti-user"></i>
                                    </span>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="address_1"
                                      id="address_1"
                                      value="290 Broadhollow Rd Suite 220 East"
                                    />{" "}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="form-label">
                                    Area/State/Zipcode{" "}
                                  </label>
                                  <div className="input-group">
                                    <span className="input-group-text ">
                                      <i className="ti-user"></i>
                                    </span>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="address_2"
                                      id="address_2"
                                      value="Melville, NY 11747"
                                    />{" "}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="form-label">Trunk </label>
                                  <div className="input-group">
                                    <span className="input-group-text ">
                                      <i className="ti-user"></i>
                                    </span>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="trunk"
                                      id="trunk"
                                      value="SIP/pilivo/+1"
                                    />{" "}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="form-label">
                                    Server Allotted{" "}
                                  </label>
                                  <select
                                    className="form-select select2 select2-hidden-accessible"
                                    name="asterisk_servers[]"
                                    id="asterisk_servers"
                                    data-placeholder="Asterisk Servers"
                                    style={{ width: "100%" }}
                                    aria-hidden="true"
                                  >
                                    <option value="1">
                                      167.99.54.193 - New York-DC1 -
                                      Airespring1/#13519621
                                    </option>
                                    <option value="6">
                                      3.234.106.186 - New York-DC1 -
                                      Airespring1/#13519621
                                    </option>
                                    <option value="7">
                                      44.215.233.38 - New York-DC1 -
                                      Airespring1/#13519621
                                    </option>
                                    <option value="8">
                                      3.234.106.186 - New York-DC1 -
                                      Airespring1/#13519621
                                    </option>
                                    <option value="9">
                                      44.215.233.38 - New York-DC1 -
                                      Airespring1/#13519621
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="form-label">
                                    Enable 2FA{" "}
                                  </label>
                                  <div className="input-daterange input-group col-md-12">
                                    <span className="input-group-text ">
                                      <i className="ti-user"></i>
                                    </span>
                                    <select
                                      className="form-select"
                                      name="enable_2fa"
                                      id="enable_2fa"
                                    >
                                      <option value="0">No</option>
                                      <option value="1">Yes</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="col-md-6"
                                style={{ marginTop: "35px" }}
                              >
                                <div className="form-group ">
                                  <input
                                    name="sms"
                                    id="sms"
                                    value="1"
                                    type="checkbox"
                                    className="filled-in chk-col-primary me-2"
                                  />
                                  <label className="me-2">SMS Plugin</label>

                                  <input
                                    name="fax"
                                    id="fax"
                                    value="1"
                                    type="checkbox"
                                    className="filled-in chk-col-primary me-2"
                                  />
                                  <label className="me-2">Fax Plugin</label>
                                  <input
                                    name="chat"
                                    id="chat"
                                    value="1"
                                    type="checkbox"
                                    className="filled-in chk-col-primary me-2"
                                  />
                                  <label className="me-2">Chat Plugin</label>

                                  <input
                                    name="webphone"
                                    id="webphone"
                                    type="checkbox"
                                    className="filled-in chk-col-primary me-2"
                                  />
                                  <label className="me-2">
                                    Webphone Plugin
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="form-label">
                                    API Token
                                  </label>
                                  <div className="input-group">
                                    <span className="input-group-text ">
                                      <i className="ti-user"></i>
                                    </span>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value="09eabc80-qbna-8027-wwrp-5b5f92fa7412"
                                      name="api_key"
                                      id="api_key"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label className="form-label">
                                    Enable MCA CRM
                                  </label>
                                  <div className="input-daterange input-group col-md-12">
                                    <span className="input-group-text ">
                                      <i className="ti-user"></i>
                                    </span>
                                    <select
                                      className="form-select"
                                      name="mca_crm"
                                      id="enable_mca_crm"
                                    >
                                      <option value="0">No</option>
                                      <option value="1">Yes</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="box-footer text-end">
                              <button
                                type="submit"
                                name="submit"
                                value="Save"
                                className="btn btn btn-primary waves-effect waves-light"
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="box box-default ">
                          <div className="box-header with-border mb-3">
                            <h3
                              className="box-title"
                              style={{ fontWeight: "bold" }}
                            >
                              SMS Provider
                            </h3>
                            <div className="box-tools pull-right"></div>
                          </div>

                          <div className="box-body">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="nav-tabs-custom">
                                  <ul
                                    className="nav nav-tabs tabs-vertical"
                                    role="tablist"
                                  >
                                    <li className="nav-item">
                                      {" "}
                                      <a
                                        className="nav-link active"
                                        data-bs-toggle="tab"
                                        href="#time"
                                        role="tab"
                                        aria-selected="true"
                                      >
                                        <span className="hidden-sm-up">
                                          <i className="ion-home"></i>
                                        </span>{" "}
                                        <span className="hidden-xs-down">
                                          DIDForSale
                                        </span>{" "}
                                      </a>{" "}
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <a
                                        className="nav-link"
                                        data-bs-toggle="tab"
                                        href="#settings"
                                        role="tab"
                                        aria-selected="false"
                                      >
                                        <span className="hidden-sm-up">
                                          <i className="ion-person"></i>
                                        </span>{" "}
                                        <span className="hidden-xs-down">
                                          PLIVO
                                        </span>
                                      </a>{" "}
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <a
                                        className="nav-link"
                                        data-bs-toggle="tab"
                                        href="#tal"
                                        role="tab"
                                        aria-selected="false"
                                      >
                                        <span className="hidden-sm-up">
                                          <i className="ion-person"></i>
                                        </span>{" "}
                                        <span className="hidden-xs-down">
                                          TELNYX
                                        </span>
                                      </a>{" "}
                                    </li>

                                    <li className="nav-item">
                                      {" "}
                                      <a
                                        className="nav-link"
                                        data-bs-toggle="tab"
                                        href="#twilio"
                                        role="tab"
                                        aria-selected="false"
                                      >
                                        <span className="hidden-sm-up">
                                          <i className="ion-person"></i>
                                        </span>{" "}
                                        <span className="hidden-xs-down">
                                          Twilio
                                        </span>
                                      </a>{" "}
                                    </li>
                                  </ul>
                                  <div className="tab-content">
                                    <div className="tab-pane active" id="time">
                                      <form
                                        className="form-horizontal form-label-left"
                                        method="post"
                                        role="form"
                                        name=""
                                        id=""
                                      >
                                        <input
                                          type="hidden"
                                          name="_token"
                                          value="NCJKyCAacIlADlO0yZraQhIO0iuYBJ9STRk3fjz1"
                                        />{" "}
                                        <input
                                          type="hidden"
                                          value="didforsale"
                                          name="provider"
                                        />
                                        <div className="form-group row m-2">
                                          <div className="col-sm-6">
                                            <label className="form-label">
                                              Auth ID
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value="XRpgqChVWfc30f8b461f40eab7f0a10789cc778fdd"
                                              name="auth_id"
                                              id="inputEmail"
                                              placeholder="Enter Auth Id"
                                            />
                                          </div>

                                          <div className="col-sm-6">
                                            <label className="form-label">
                                              Auth Token
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value="eAEDnhtLXxM1LCeDoDHNd8mbSdqDs840yvj"
                                              name="api_key"
                                              id="inputEmail"
                                              placeholder="Enter Key"
                                            />
                                          </div>
                                        </div>
                                        <div className="form-group row m-2">
                                          <div className="col-sm-3">
                                            <label className="form-label">
                                              Label
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value=""
                                              name="label_name"
                                              id="inputEmail"
                                              placeholder="Enter Label Name"
                                            />
                                          </div>

                                          <div className="col-sm-3">
                                            <label className="form-label">
                                              Host
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value=""
                                              name="host"
                                              id="inputEmail"
                                              placeholder="Enter Host"
                                            />
                                          </div>

                                          <div className="col-sm-3">
                                            <label className="form-label">
                                              SIP Username
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value=""
                                              name="sip_username"
                                              id="inputEmail"
                                              placeholder="Enter SIP username"
                                            />
                                          </div>

                                          <div className="col-sm-3">
                                            <label className="form-label">
                                              SIP Password
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value=""
                                              name="sip_password"
                                              id="inputEmail"
                                              placeholder="Enter SIP Password"
                                            />
                                          </div>
                                        </div>
                                        <div className="form-group row m-2">
                                          <div className="col-sm-6">
                                            <label className="form-label">
                                              Access Token For SMS AI
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value=""
                                              name="access_token"
                                              id="inputEmail"
                                              placeholder="Enter Access Token"
                                            />
                                          </div>

                                          <div className="col-sm-6">
                                            <label className="form-label">
                                              SMS Url For SMS AI
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value=""
                                              name="sms_ai_url"
                                              id="inputEmail"
                                              placeholder="Enter Sms Url"
                                            />
                                          </div>
                                        </div>
                                        <div className="card-footer text-end">
                                          <button
                                            type="submit"
                                            className="btn btn-primary"
                                          >
                                            Submit
                                          </button>
                                        </div>
                                      </form>
                                    </div>

                                    <div className="tab-pane" id="settings">
                                      <form
                                        className="form-horizontal form-label-left"
                                        method="post"
                                      >
                                        <input
                                          type="hidden"
                                          name="_token"
                                          value="NCJKyCAacIlADlO0yZraQhIO0iuYBJ9STRk3fjz1"
                                        />{" "}
                                        <input
                                          type="hidden"
                                          value="plivo"
                                          name="provider"
                                        />
                                        <div className="form-group row m-2">
                                          <div className="col-sm-6">
                                            <label className="form-label">
                                              Auth ID
                                            </label>

                                            <input
                                              type="text"
                                              className="form-control"
                                              value="MAMWEZYZM1MWUWOTLHNZ"
                                              name="auth_id"
                                              id="inputEmail"
                                              placeholder="Enter Auth Id"
                                            />
                                          </div>

                                          <div className="col-sm-6">
                                            <label className="form-label">
                                              Auth Token
                                            </label>

                                            <input
                                              type="text"
                                              className="form-control"
                                              value="MTNjY2UxYjM5NzczMzQ0MDEwMDM5NmNjZjYwNGQ4"
                                              name="api_key"
                                              id="inputEmail"
                                              placeholder="Enter key"
                                            />
                                          </div>
                                        </div>
                                        <div className="form-group row m-2">
                                          <div className="col-sm-3">
                                            <label className="form-label">
                                              Label
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value=""
                                              name="label_name"
                                              id="inputEmail"
                                              placeholder="Enter Label Name"
                                            />
                                          </div>

                                          <div className="col-sm-3">
                                            <label className="form-label">
                                              Host
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value=""
                                              name="host"
                                              id="inputEmail"
                                              placeholder="Enter Host"
                                            />
                                          </div>

                                          <div className="col-sm-3">
                                            <label className="form-label">
                                              SIP Username
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value=""
                                              name="sip_username"
                                              id="inputEmail"
                                              placeholder="Enter SIP username"
                                            />
                                          </div>

                                          <div className="col-sm-3">
                                            <label className="form-label">
                                              SIP Password
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value=""
                                              name="sip_password"
                                              id="inputEmail"
                                              placeholder="Enter SIP Password"
                                            />
                                          </div>
                                        </div>
                                        <div className="form-group row m-2">
                                          <div className="col-sm-6">
                                            <label className="form-label">
                                              Access Token For SMS AI
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value=""
                                              name="access_token"
                                              id="inputEmail"
                                              placeholder="Enter Access Token"
                                            />
                                          </div>

                                          <div className="col-sm-6">
                                            <label className="form-label">
                                              SMS Url For SMS AI
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value=""
                                              name="sms_ai_url"
                                              id="inputEmail"
                                              placeholder="Enter Sms Url"
                                            />
                                          </div>
                                        </div>
                                        <div className="card-footer text-end">
                                          <button
                                            type="submit"
                                            className="btn btn-primary waves-effect waves-light"
                                          >
                                            Submit
                                          </button>
                                        </div>
                                      </form>
                                    </div>
                                    <div className="tab-pane" id="tal">
                                      <form
                                        className="form-horizontal form-label-left"
                                        method="post"
                                        role="form"
                                        name=""
                                        id=""
                                      />
                                      <input
                                        type="hidden"
                                        name="_token"
                                        value="NCJKyCAacIlADlO0yZraQhIO0iuYBJ9STRk3fjz1"
                                      />{" "}
                                      <input
                                        type="hidden"
                                        value="telnyx"
                                        name="provider"
                                      />
                                      <div className="form-group row m-2">
                                        <div className="col-sm-6">
                                          <label className="form-label">
                                            Auth Token
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            name="api_key"
                                            value=""
                                            id="inputEmail"
                                            placeholder="Enter Key"
                                          />
                                        </div>

                                        <div className="col-sm-6">
                                          <label className="form-label">
                                            Telnyx API Url
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value=""
                                            name="domain_api_url"
                                            id="inputEmail"
                                            placeholder="Enter Domain Name"
                                          />
                                        </div>
                                      </div>
                                      <div className="form-group row m-2">
                                        <div className="col-sm-3">
                                          <label className="form-label">
                                            Label
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value=""
                                            name="label_name"
                                            id="inputEmail"
                                            placeholder="Enter Domain Name"
                                          />
                                        </div>

                                        <div className="col-sm-3">
                                          <label className="form-label">
                                            Host
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value=""
                                            name="host"
                                            id="inputEmail"
                                            placeholder="Enter Domain Name"
                                          />
                                        </div>

                                        <div className="col-sm-3">
                                          <label className="form-label">
                                            SIP Username
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value=""
                                            name="sip_username"
                                            id="inputEmail"
                                            placeholder="Enter Domain Name"
                                          />
                                        </div>

                                        <div className="col-sm-3">
                                          <label className="form-label">
                                            SIP Password
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value=""
                                            name="sip_password"
                                            id="inputEmail"
                                            placeholder="Enter Domain Name"
                                          />
                                        </div>
                                      </div>
                                      <div className="form-group row m-2">
                                        <div className="col-sm-6">
                                          <label className="form-label">
                                            Access Token For SMS AI
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value=""
                                            name="access_token"
                                            id="inputEmail"
                                            placeholder="Enter Access Token"
                                          />
                                        </div>

                                        <div className="col-sm-6">
                                          <label className="form-label">
                                            SMS Url For SMS AI
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value=""
                                            name="sms_ai_url"
                                            id="inputEmail"
                                            placeholder="Enter Sms Url"
                                          />
                                        </div>
                                      </div>
                                      <div className="card-footer text-end">
                                        <button
                                          type="submit"
                                          className="btn btn-primary"
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                    <div className="tab-pane" id="twilio">
                                    <form
                                      className="form-horizontal form-label-left"
                                      method="post"
                                      role="form"
                                      name=""
                                      id=""
                                    >
                                      <input
                                        type="hidden"
                                        name="_token"
                                        value="NCJKyCAacIlADlO0yZraQhIO0iuYBJ9STRk3fjz1"
                                      />{" "}
                                      <input
                                        type="hidden"
                                        value="twilio"
                                        name="provider"
                                      />
                                      <div className="form-group row m-2">
                                        <div className="col-sm-6">
                                          <label className="form-label">
                                            Auth ID
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            name="auth_id"
                                            id="inputEmail"
                                            value="ACa6b756f8a95aff28adef5d101f8b1173"
                                            placeholder="Enter Auth Id"
                                          />
                                        </div>

                                        <div className="col-sm-6">
                                          <label className="form-label">
                                            Auth Token
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            name="api_key"
                                            value="fa90f292473da4589b5b1745488fc467"
                                            id="inputEmail"
                                            placeholder="Enter Key"
                                          />
                                        </div>
                                      </div>
                                      <div className="form-group row m-2">
                                        <div className="col-sm-3">
                                          <label className="form-label">
                                            Label
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value=""
                                            name="label_name"
                                            id="inputEmail"
                                            placeholder="Enter Domain Name"
                                          />
                                        </div>

                                        <div className="col-sm-3">
                                          <label className="form-label">
                                            Host
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value=""
                                            name="host"
                                            id="inputEmail"
                                            placeholder="Enter Domain Name"
                                          />
                                        </div>

                                        <div className="col-sm-3">
                                          <label className="form-label">
                                            SIP Username
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value=""
                                            name="sip_username"
                                            id="inputEmail"
                                            placeholder="Enter Domain Name"
                                          />
                                        </div>

                                        <div className="col-sm-3">
                                          <label className="form-label">
                                            SIP Password
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value=""
                                            name="sip_password"
                                            id="inputEmail"
                                            placeholder="Enter Domain Name"
                                          />
                                        </div>
                                      </div>
                                      <div className="form-group row m-2">
                                        <div className="col-sm-6">
                                          <label className="form-label">
                                            Access Token For SMS AI
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value=""
                                            name="access_token"
                                            id="inputEmail"
                                            placeholder="Enter Access Token"
                                          />
                                        </div>

                                        <div className="col-sm-6">
                                          <label className="form-label">
                                            SMS Url For SMS AI
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value=""
                                            name="sms_ai_url"
                                            id="inputEmail"
                                            placeholder="Enter Sms Url"
                                          />
                                        </div>
                                      </div>
                                      <div className="card-footer text-end">
                                        <button
                                          type="submit"
                                          className="btn btn-primary"
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                  </div>

                                  
                                </div>
                              </div>
                            </div>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <div  className="row">
   <div  className="col-xs-12">
       <div  className="box">
           <div  className="box-body">
               <h3 style={{marginBottom: '20px'}}>Manual Subscription Assignment</h3>
               <form method="post" role="form" name="manualSubscriptionForm" id="manualSubscriptionForm" action="https://portal.voiptella.com/client/manual-subscription">
                   <input type="hidden" name="_token" value="XRQNCfcSGa2e0WeMAiMUM1AgP8f3YkAkQEpFI06t"/>                                          <div  className="row">
                           <div  className="col-md-4">
                               <div  className="form-group">
                                   <label className="form-label">Subscription</label>
                                   <div  className="input-daterange input-group col-sm-12 col-xs-12">
                                       <select id="package" name="package"  className="form-select">
                                           <option value="#">Select Subscription</option>
                                                                                          <option value="1b6d9247-78fb-4b8e-b110-359910fbe774">CRM</option>
                                                                                          <option value="588703ba-e78a-430f-8872-bb088dc1abba">Trial</option>
                                                                                          <option value="91620d9c-e6d6-4e98-bd66-86bf186a5a3c">Enterprise CRM</option>
                                                                                          <option value="351efbf7-b367-43a9-ac57-27f918a934d7">Starter Unlimited</option>
                                                                                          <option value="972384c6-f2c8-4685-977a-eea1f345c1e5">Standard Unlimited</option>
                                                                                          <option value="4eaabb90-2265-413e-8a6c-70dffe906c92">Premium</option>
                                                                                          <option value="87924e8f-301b-4616-949f-a3b0d850c136">Virtual Number</option>
                                                                                  </select>
                                   </div>
                               </div>
                           </div>
                           <div  className="col-md-4">
                               <div  className="form-group">
                                   <label className="form-label">Billing</label>
                                   <div  className="input-daterange input-group col-sm-12 col-xs-12">
                                       <select id="billing" name="billing"  className="form-select" >
                                           <option value="#">Select Billing Period</option>
                                           <option value="4">Yearly</option>
                                           <option value="3">Half Yearly</option>
                                           <option value="2">Quarterly</option>
                                           <option value="1">Monthly</option>
                                       </select>
                                   </div>
                               </div>
                           </div>
                           <div  className="col-md-4">
                               <div  className="form-group">
                                   <label className="form-label">Quantity</label>
                                   <div  className="input-daterange input-group col-sm-12 col-xs-12">
                                   <div  className="number-of-users">
                                                        <span  className="minus" data-page="cart"><span  className="glyphicon glyphicon-minus"></span></span>
                                                        <input
                                      type="text"
                                      className="form-control quantity-field"
                                      name="quantity"
                                      id="trunk"
                                      value="0"
                                    />
                                    
                                                        <span  className="plus" data-page="cart"><span  className="glyphicon glyphicon-plus"></span></span>
                                                    </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                       <hr/>
                       <div  className="box-footer text-end">
                                   <input type="hidden"  className="form-control" name="parent" value="1" />
                                   <input type="submit" id="submitbtn"  className="btn btn-primary" value="Submit"/>
                        
                                  
           </div></form>
       </div>
   </div>
   <div  className="col-xs-12" style={{marginBottom:'40px'}}>
       <div  className="box">
           <div  className="box-body">
               <h3 style={{marginBottom:'20px'}}>Credit Wallet</h3>
               <form method="post" role="form" name="manualCreditWallet" id="manualCreditWallet" action="https://portal.voiptella.com/client/credit-wallet">
                   <input type="hidden" name="_token" value="XRQNCfcSGa2e0WeMAiMUM1AgP8f3YkAkQEpFI06t"/>                                         
                    <div  className="row">
                           <div  className="col-md-4">
                               <div  className="form-group">
                                   <label className="form-label" >Amount</label>
                                   <input type="text"  className="form-control" name="amount" id="amount"   placeholder="Enter Amount" />
                               </div>
                           </div>
                       </div>
                       <hr/>
                       <div  className="box-footer text-end">
                         
                                   <input type="hidden"  className="form-control" name="parent" value="1" />
                                   <input type="submit" id="submitbtn"  className="btn btn-primary" value="Submit" />
                               </div>
                          
                       </form></div>
                                  
           </div>
       </div>
   </div>
</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* /Page Wrapper */}
      </>
    </>
  );
};

export default ClientsEdit;
